import React from "react"

const NotFound = () => {
  return (
    <div>
      <p>You took a wrong turn, mate.</p>
    </div>
  )
}

export default NotFound
